import { UpdateAccountForm } from '@/containers/update-account-form';
import { ROUTES } from '@/routes';
import { ChevronLeftIcon } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

export const UpdateAccountPage = () => {
  const navigate = useNavigate();

  return (
    <div
      className="flex h-[100vh] flex-col items-center  overflow-y-auto bg-gr-50"
      style={{
        padding: 'clamp(80px, 20vh, 272px)', // 최소 80px, 최대 272px, 20vh 비율로 유동
      }}
    >
      <div className="space-y-5">
        <button className="flex items-center gap-3" onClick={() => navigate(-1)}>
          <ChevronLeftIcon width={32} height={32} />
          <div className="text-gr-900 Title2S24">이메일 계정 등록</div>
        </button>
        <UpdateAccountForm
          onCompleted={() => {
            navigate(ROUTES.root);
          }}
        />
      </div>
    </div>
  );
};
